import { render, staticRenderFns } from "./Tile.vue?vue&type=template&id=57797062&"
import script from "./Tile.vue?vue&type=script&lang=js&"
export * from "./Tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsPlayButton: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/PlayButton.vue').default})
